import { FaEye, FaUserLock } from "react-icons/fa";
import { ReportType } from "./index.type"
import EditModule from "./EditModule";
import DeleteModule from "./DeleteModule";
import UserAndGroupAssignment from "./UserAndGroupAssignment";
import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { useNotification } from "src/hooks/useNotification";
import { t } from "i18next";
import useCallApi from "src/hooks/useCallApi";
import { CircleLoader } from "src/components/Loader";
import { useContext } from "react";
import { ReportManagementPageContext } from "src/contextAPI/reportManagementPageContext";

export function Access({ report }: { report: ReportType }) {
    return <section>
        {report.isPublic === false
            ? <div className="flex justify-center items-center gap-2">
                <FaUserLock style={{ fill: '#636060', minWidth: '15px' }} />
                <h2>{t("reportManagement.table.private")}</h2>
            </div>
            : <h2>{t("reportManagement.table.public")}</h2>
        }
    </section>
}

export function Actions({ report }: { report: ReportType }) {
    const { t } = useTranslation();
    const { contextHolder } = useNotification();
    return (
        <ul className="flex justify-center items-center gap-5">
            <li className="cursor-pointer text-[#857f7f] hover:text-red-500">
                <Tooltip placement="left" color='#4d4c4c' title={t('reportManagement.editmodule.title')}>
                    <>
                        <EditModule report={report} />
                    </>
                </Tooltip>
            </li>

            <li className="cursor-pointer text-[#857f7f] hover:text-red-500">
                <Tooltip placement="left" color='#4d4c4c' title={t('reportManagement.userAndGroups.title')}>
                    <>
                        <UserAndGroupAssignment report={report} />
                    </>
                </Tooltip>
            </li>
            <li className="cursor-pointer text-[#857f7f] hover:text-red-500">
                <Tooltip placement="left" color='#4d4c4c' title={t('reportManagement.deletemodule.title')}>
                    <>
                        <DeleteModule report={report} />
                    </>
                </Tooltip>
                {contextHolder}
            </li>
        </ul>
    )
}

export function UserGroupCount({ report }: { report: ReportType }) {
    const { t } = useTranslation();
    const { callApi, callApiLoading } = useCallApi();
    const { userGroupCountCache, setUserGroupCountCache } = useContext(ReportManagementPageContext);

    const cachedCount = userGroupCountCache[report.id];

    const handleClick = async () => {
        if (callApiLoading || cachedCount !== undefined) return;
        document.body.classList.add('report-eyes-busy');
        try {
            const res: any = await callApi({ endpoint: 'UserGroupCount', query: report.id });
            if (res && typeof res.userCount === 'number') {
                setUserGroupCountCache(prev => ({ ...prev, [report.id]: res.userCount }));
            }
        } finally {
            document.body.classList.remove('report-eyes-busy');
        }
    };

    return (
        <section className="flex justify-center items-center">
            {cachedCount !== undefined ? (
                <span>{cachedCount}</span>
            ) : callApiLoading ? (
                <CircleLoader />
            ) : (
                <Tooltip placement="top" color="#4d4c4c" title={t('reportManagement.table.showCount')}>
                    <FaEye className="report-eye cursor-pointer text-[#857f7f] hover:text-red-500" size={16} onClick={handleClick} />
                </Tooltip>
            )}
        </section>
        // <span>{report.userCount}</span>
    );
}
